export default "__VITE_ASSET__g89m_2Yn__"